// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attaching-images-item[data-v-47bbd410]{display:table-row}.actions[data-v-47bbd410]{display:flex;align-items:center}.cell[data-v-47bbd410]{display:table-cell;vertical-align:middle;padding-bottom:10px}.color-picker[data-v-47bbd410]{margin-right:19px}.scope-key[data-v-47bbd410]{width:112px}.remove-icon[data-v-47bbd410]{cursor:pointer;fill:#929bae}", ""]);
// Exports
module.exports = exports;
